export default "__VITE_ASSET__DGfImTHT__"